import { mixpanel } from '@fiverr-private/obs';
import { FilterLocation } from '../../types';
import store from '../../store';
import { MIXPANEL_EVENT_PROPERTIES } from '../../../../shared/mixpanel';

type Filter = 'Brand Name' | 'Industry' | 'Style' | 'Elements';

/**
 * The user clicked on one of the filters - Brand Name, Industry, Style, Elements
 */
export const reportFilterClicked = (
    filter: Filter,
    filterLocation: FilterLocation
) => {
    mixpanel.track('Logo Maker - MPI - Filter Clicked', {
        ...store.brief.getData(),
        ...store.user.getData(),
        ...store.listingsType.getData(),
        [MIXPANEL_EVENT_PROPERTIES.FILTER]: filter,
        [MIXPANEL_EVENT_PROPERTIES.FILTER_LOCATION]: filterLocation,
    });
};
